import { Component, OnInit, Input, Output, EventEmitter, trigger, state, style, transition, animate } from '@angular/core';

@Component({
  selector: 'cm-entete',

  template: `

      <div class="cadre-entete-haut" [@afficherCacherEntete]="etatEntete">

        <div class="cadre-images">
          <div class="cadre-image">
            <img class="img img-logo-carte-mariale" 
                src="./assets/images/logo-carte-mariale.png">
          </div>
          <div class="cadre-image cadre-image-marie-nazareth">
            <img class="img img-logo-marie-nazareth" 
                src="./assets/images/logo-marie-de-nazareth.png">
          </div>
        </div>

        <div>
          <h4 class="marie-de-nazareth">Marie de Nazareth<span class="small">&reg;</span> présente </h4>
        </div>

        <div>
          <h1>La carte mariale <br> du monde</h1>
        </div>

        <div>
          <h4 class="h4-seule-carte">La seule carte interactive qui rassemble<br> tous les lieux marials du monde</h4>
        </div>

        <div
          class="pastille-voyage-avec-marie"
          [style.background]="pastilleEnteteCouleur()"
          (click)="cacherEntete()">
          
          <div class="pastille-voyage-avec-marie-texte"
              [style.margin-top]="pastilleTexteMargeHaut()"
              [innerHTML]="pastilleEnteteTexte()"> 
          </div>
        </div>

      </div>

      <div 
        class="pastille-voyage-avec-marie pastille-invisible-mobile"
        [style.background]="pastilleEnteteCouleur()"
        (click)="cacherEntete()"
        [@afficherCacherPastille]="etatEntete">
        
        <div class="pastille-voyage-avec-marie-texte"
            [style.margin-top]="pastilleTexteMargeHaut()"
            [innerHTML]="pastilleEnteteTexte()"> 
        </div>
      </div>

      <div [@afficherCacherEnteteBas]="etatEntete" class="cadre-entete-bas"></div>
  `,
  styles: [`
  .cadre-entete {
        position: absolute;
        left :0;
        top: 0;
        height: 100vh;
        width: 100vw;
        z-index: 10;
    }
    .cadre-entete-haut {
        position: absolute;
        left: 0;
        top: 0;
        background-color: white;
        height: 65vh;
        width: 100vw;
        border: 1px solid lightgray;
        opacity: 1;
        z-index: 10;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        padding-bottom: 80px;
    }
    .cadre-entete-bas {
        position: absolute;
        left :0;
        top: 65vh;
        background-color: rgba(0,53,82,0.5);
        height: calc(35vh - 50px);
        width: 100vw;
        z-index: 9;
    }
    h1 {
        font-size: 70px;
        line-height: 90px;
        text-transform: uppercase;
        color: #006296;
    }
    h4 {
        font-size: 25px;
        line-height: 30px;
        font-weight: 400;
        color: #012D47;
    }
    h1, h4 {
        text-align: center;
    }
    .cadre-images {
        display: flex;
        justify-content: space-around;
    }
    img {
        height: 100px;
    }
    .pastille-voyage-avec-marie {
        font-family: "Edo SZ", "Helvetica Neue",Helvetica,Arial,sans-serif;
        position: absolute;
        width: 154px;
        height: 154px;
        top: calc(65vh - 77px);
        left: calc(50vw - 77px);
        padding-top: 3vh;
        border-radius: 50%;
        font-size: 30px;
        color: white;
        line-height: 35px;
        text-align: center;
        z-index: 15;
        cursor: pointer;
    }
    .pastille-voyage-avec-marie-texte {
        color: white;
    }
    .glyphicon {
        font-size: 40px;
    }

    @media (max-width: 1000px) {
      h1 {
        font-size: 60px;
        line-height: 70px;
        margin-top: 20px;
      }
      h4 {
          margin-top: 20px;
      }
    }

    @media (max-width: 800px), (max-height: 700px) {
      .cadre-entete-haut {
          height: 78vh;
      }
      h1 {
        font-size: 30px;
        line-height: 35px;
        padding-left: 10px;
        padding-right: 10px;
      }
      h4 {
        font-size: 16px;
        line-height: 18px;
        margin-top: 5px;
      }
      .h4-seule-carte {
        margin-top: 10px;
      }
      .cadre-images {
        flex-direction: column;
        justity-content: space-around;
        text-align: center;
        margin-top: 10px;
      }

      .cadre-image-marie-nazareth {
        visibility: hidden;
        height: 0;
      }

      .img-logo-marie-nazareth {
        visibility: hidden;
        height: 0;
      }

      .img-logo-carte-mariale {
        margin: 0;
        padding-bottom: 5px;
        height: 200px;
        max-height: 20vh;
      }

      .pastille-voyage-avec-marie {
         top: calc(78vh - 77px);
      }
      .pastille-invisible-mobile {
        visibility: hidden;
      }
      .marie-de-nazareth {
        margin-top: 50px;
      }
      .cadre-entete-bas {
          top: 78vh;
          height: 22vh;
      }
    }

     @media (max-height: 430px) {
       .pastille-voyage-avec-marie {
         height: 100px;
         width: 100px;
         left: calc(50vw - 50px);
         font-size: 16px;
         line-height: 20px;
         padding-top: 10px;
       }
     }
  `],

  animations: [
    trigger('afficherCacherEntete', [
      state('visible', style({
        transform: 'translateY(0) scale(1, 1)'
      })),
      state('invisible', style({
        transform: 'translateY(-100%) scale(1, 0)'
      })),
      transition('visible => invisible', animate('400ms ease-in-out')),
      transition('invisible => visible', animate('400ms ease-in-out'))
    ]),
    trigger('afficherCacherEnteteBas', [
      state('visible', style({
        transform: 'translateY(0) scale(1, 1)'
      })),
      state('invisible', style({
        transform: 'translateY(100%) scale(1, 0)'
      })),
      transition('visible => invisible', animate('400ms ease-in-out')),
      transition('invisible => visible', animate('400ms ease-in-out'))
    ]),
    trigger('afficherCacherPastille', [
      state('visible', style({
        transform: 'translateY(0)'
      })),
      state('invisible', style({
        transform: 'translateY(-65vh)'
      })),
      transition('visible => invisible', animate('400ms ease-in-out')),
      transition('invisible => visible', animate('400ms ease-in-out'))
    ])
  ]
})
export class EnteteComponent implements OnInit {

  @Input() etatEntete: string;
  @Output() changerEtatEntete: EventEmitter<string> = new EventEmitter();

  constructor() {}

  ngOnInit() {
  }

  cacherEntete() {
    this.etatEntete = this.etatEntete === 'invisible' ? 'visible' : 'invisible';
    this.changerEtatEntete.emit(this.etatEntete);
  }

  pastilleTexteMargeHaut(): string {
    return this.etatEntete === 'visible'? '0' : '15px';
  }

  pastilleEnteteTexte(): string {
    return this.etatEntete === 'visible'?
        'Travel <br> with Mary <br> <img width="40px" src="./assets/images/fleche-bas.png"/>'
        : '<br>Home <br> <img width="40px" src="./assets/images/fleche-haut.png"/>';
  }

  pastilleEnteteCouleur(): string {
    return this.etatEntete === 'visible'? '#FFA300' : 'rgb(0, 98, 150)';
  }
}



// WEBPACK FOOTER //
// ./src/app/components/entete.component.ts